import { render, staticRenderFns } from "./AdditionalFilters.vue?vue&type=template&id=36033254&scoped=true&"
import script from "./AdditionalFilters.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFilters.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalFilters.vue?vue&type=style&index=0&id=36033254&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36033254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VContainer,VIcon})
